import axios from 'axios'

export default {
    async fetchAll() {
        const response = await axios.get('/api/platforms');
        return response.data.platforms;
    },
}
